import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `access`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'access',
  permission: 'roles.manage',
} satisfies AdminPageAccessRule;
